export default function SubtleAnimalLogo({ className, style }) {
  return (
    <img
      src="/brand-logo-leaf.png"
      alt="Subtle Animal"
      className={className}
      style={style}
    />
  );
}
